import { render, staticRenderFns } from "./Xterminate.vue?vue&type=template&id=35bba558&"
import script from "./Xterminate.vue?vue&type=script&lang=js&"
export * from "./Xterminate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports